import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Header from "../../Header/header";
import V10Reports_Template from "../V10Reports_Template";
import V11Reports_Template from "../v11Reports_Template";
import TransactionServices from "../TransactionServices";
import YoutubeTemporaryBox from "./YoutubeTemporaryTable";
import ViewUploadFileLogBox from "./ViewUploadFileLog";

export default function YoutubeRed(subEntity: any) {

    const [showtab, setShowTab] = useState(1);
    const [loop, setloop] = useState(1);
    let [activeMenu, setActiveMenu] = useState("YoutubeRed");


    const [searchFor, setSearchFor] = useState("");
    var dataLink = "pageSize=10&pageNumber=1";
    const [currentList, initCurrentList] = useState<any[]>([]);
    const [totalRows, setTotalRows] = useState(1);


    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    const [displaytabs, setDisplayTabs] = useState(1);
    /* const currentPage = (e: React.SetStateAction<number>) => {
        setDisplayTabs(e);
        return 1;
    } */

    const tabs = [
        {
            id: 1, keys: "V1.0 Reports", title: "V1.0 Reports"
        },
        {
            id: 2, keys: "V1.1 Reports", title: "V1.1 Reports"
        },
    ]

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        totalRows: 0
    }

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        dataLink = 'pageSize=' + Data.pageSize + '&pageNumber=' + Data.pageNumber;
        currentPage(showtab)
    }

    const currentPage = (e: number) => {
        setShowTab(e);

        if (searchFor.length > 0) {
            dataLink = dataLink + "&searchFor=" + searchFor
        }
        if (e === 1) {
            TransactionServices.youtubeRedV1Reports(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
        if (e === 2) {
            TransactionServices.youtubeRedV1_1Reports(dataLink).then((res) => {
                initCurrentList(res)
                if (res.length < 1) { setTotalRows(0) }
                else { setTotalRows(res[0].totalRows); }
            })
        }
    }

    let [checkNoDate, setCheckNoDate] = useState(false);
    let [checkRawReport, setCheckRawReport] = useState(false);
    let [checkReportData, setCheckReportData] = useState(false);
    let [checkReportNoDate, setCheckReportNoDate] = useState(false);
    let [getReportSuccess, setGetReportSuccess] = useState(false);
    let [deleteReportMsg, setDeleteReportMsg] = useState(false);

    let [youtubeRedTemporaryTableStatus, setYoutubeRedTemporaryTableStatus] = useState(false);
    const youtubeRedTemporaryTable = () => {
        setYoutubeRedTemporaryTableStatus(true)
    }
    let [openYoutubeRedTemporaryTableStatus, setOpenYoutubeRedTemporaryTableStatus] = useState(false);
    const YoutubeTemporaryTableClose = () => {
        youtubeRedTemporaryTableStatus = false
        setYoutubeRedTemporaryTableStatus(false)
    }


    let [fileUploadHistoryStatus, setFileUploadHistoryStatus] = useState(false);
    const viewUploadHistory = () => {
        fileUploadHistoryStatus = true;
        setFileUploadHistoryStatus(fileUploadHistoryStatus)
    }

    let [collapsedFileDetails, setcollapsedFileDetails] = useState(false);
    let [collapsedGetReport, setcollapsedGetReport] = useState(false);

    return (

        <div className="ws-12 pm">

            <div className="box-content">
                <ul className="nav nav-tabs nav-justified">
                    <li data-ng-className="{active: isActiveTab('youtubeRedV10')}" data-ng-click="openTab('youtubeRedV10')" className="hide">
                        <a >V1.0 Reports</a>
                    </li>
                    <li data-ng-className="{active: isActiveTab('youtubeRedV11')}" data-ng-click="openTab('youtubeRedV11')" className="hide">
                        <a>V1.1 Reports</a>
                    </li>

                    <a id="1" className={showtab === 1 ? "btn-success active" : "btn-success"} onClick={() => currentPage(1)}>V1.0 Reports</a>
                    <a id="2" className={showtab === 2 ? "btn-success active" : "btn-success"} onClick={() => currentPage(2)}>V1.1 Reports</a>

                </ul>

                <div className="slide box" data-ng-show="isActiveTab('youtubeRedV10')">

                    <div className="box-header">
                        <h2 className="ws-8">
                            <i className="icon-upload"></i> File Details
                        </h2>

                        <button className="icon-btn info pull-right m2" onClick={() => setcollapsedFileDetails(!collapsedFileDetails)}>
                            <i className={collapsedFileDetails ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                        </button>
                        {collapsedFileDetails && <>
                            <button title="File Upload History" className="icon-btn info pull-right" onClick={() => viewUploadHistory()}><i className="icon-history"></i> </button>
                            <button title="Check Temporary Table" className="icon-btn warning pull-right" onClick={() => youtubeRedTemporaryTable()}><i className="icon-doc-file"></i> </button>
                            <button title="Refresh File Details" className="icon-btn edit pull-right" data-ng-click="youtubeRedRefresh()">
                                <i className="icon-refresh"></i>
                            </button>
                        </>}
                    </div>
                    {collapsedFileDetails && <>
                        <div className="box-content" >
                            {
                                checkNoDate && <div className="alert alert-info">Please select a month</div>
                            }
                            {
                                checkRawReport && <div className="alert alert-info">Data must be uploaded for both Raw and Report</div>
                            }

                            <div className="ws-12">
                                <div className="ws-6">
                                    <div className="ws-5 pt">
                                        <label className="ws-4 text-right pts ">  Upload File</label>
                                        <div className="ws-8">
                                            <label className="btn icon-btn edit btn-file btn-sm">Browse
                                                <input type="file" className="hide" />
                                            </label>

                                        </div>
                                    </div>

                                    <div className="ws-6 pt">
                                        <div className="progress">
                                            <div className="btn-lightBlue " role="progressbar">
                                                0%
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-format ws-6">
                                    <span className="ws-12"><i className="fa fa-calendar"></i>Date</span>
                                    <div className="label-entries">
                                        <input type="text" placeholder="Select month and year" readOnly id="rawDataDate" name="rawDataDate" />
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="box-footer" >
                            <button className="icon-btn warning pull-left btn-sm" data-ng-show="combineCount != 0" data-ng-click="youtubeRedClear()">
                                <i className="icon-close"></i> Clear Table
                            </button>

                            <button className="btn icon-btn edit pull-left btn-sm" data-ng-show="count != 0 &amp;&amp; !validate" data-ng-click="processData(rawDataDate)">
                                <i className="icon-calculator"></i> Process
                            </button>

                            <div className="ws-6 pull-right ng-hide" data-ng-show="combineCount != 0">
                                <div className="input-group">
                                    <span className="input-group-addon ">View Data For</span>
                                    <select className="form-control " ng-model="v10Reports" ng-change="youtubeSelect(v10Reports)">
                                        <option value="" >Choose an account</option>
                                        <option value="v10Video" >Video Report</option>
                                        <option value="v10NonMusicAsset" >Non-Music Asset Report</option>
                                        <option value="v10NonMusicVideo" >Non-Music Video Report</option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </>}

                </div>


                <div className="box ng-hide" data-ng-show="youtubeRedViewAll">
                    <div className="box-header well">
                        <h2 data-ng-bind="count + ' record(s) found' " >0 record(s) found</h2>
                    </div>

                    <div className="box-content">
                        <div className="alert alert-success " data-ng-show="count == 0">No data found for this month </div>
                        <div className="table-responsive_big">
                            <table className="table ng-hide" data-ng-show="count &gt; 0">
                                <thead>

                                </thead>
                                <tbody>

                                </tbody>
                            </table>
                        </div>
                        <div className="clearfix">

                        </div>
                    </div>

                    <div className="box mb">
                        <div className="box-header well">
                            <h2 className="ws-6"><i className="icon-upload"></i> Get Report</h2>

                            <div className="ws-6">
                                <button className="icon-btn info pull-right m2" onClick={() => setcollapsedGetReport(!collapsedGetReport)}>
                                    <i className={collapsedGetReport ? 'icon-angle-up' : 'icon-angle-down'} ></i>
                                </button>
                            </div>
                        </div>

                        {collapsedGetReport && <>
                            <div className="box-content" data-ng-hide="collapsedGetReport">
                                <div className="row-fluid form-horizontal form-condensed m0 ml">
                                    <div className="ws-4">
                                        <div className="form-format">
                                            <label className="control-label">Date</label>
                                            <div className="label-entries">
                                                <input type="text" placeholder="Select month and year" data-ng-click="open($event,'getReportDate')" data-ng-model="getReportDate" is-open="datepickers.getReportDate" readOnly id="getReportDate" name="getReportDate" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="label-entries">
                                        <a className="btn icon-btn edit mb" data-ng-click="getReportCombinedDetailsForDate(getReportDate)">
                                            <span data-ng-hide="reportCombinedDetails.length &gt; 0"><i className="icon-search1"></i> Search</span>
                                            <span data-ng-show="reportCombinedDetails.length &gt; 0" className="ng-hide"><i className="icon-reload"></i> Refresh</span>
                                        </a>
                                    </div>
                                </div>

                                <div className="row-fluid">
                                    <div className="table-responsive_big">

                                        {
                                            checkReportData && <div className="alert alert-ing">No data found for this month</div>
                                        }
                                        {
                                            checkReportNoDate && <div className="alert alert-ing">Please select a month</div>
                                        }
                                        {
                                            getReportSuccess && <div className="alert alert-ing">Generation of Report(s) in
                                                process</div>
                                        }
                                        {
                                            deleteReportMsg && <div className="alert alert-ing">Report successfully deleted</div>
                                        }

                                        <table className="table ng-hide" data-ng-show="countCombinedData &gt; 0">
                                            <thead>
                                                <tr>
                                                    <th>Album</th>
                                                    <th>Artist</th>
                                                    <th>Title</th>
                                                    <th>Category</th>
                                                    <th>ISRC</th>
                                                    <th>UPC</th>
                                                    <th>Territory</th>
                                                    <th>Total View</th>
                                                    <th>Revenue</th>
                                                    <th>Label</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="clearfix">
                                        <ul className="pull-left pagination ng-isolate-scope ng-valid ng-hide" total-items="countCombinedData" data-ng-model="pageNumberReport" max-size="3" data-ng-change="reportDetailPageChanged(pageNumberReport)" data-ng-show="countCombinedData &gt; 10">

                                            <li ng-if="::directionLinks" ng-className="{disabled: noPrevious()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page - 1, $event)" >Previous</a></li>
                                            <li ng-repeat="page in pages track by $index" ng-className="{active: page.active,disabled: ngDisabled&amp;&amp;!page.active}" className=" active"><a href="" ng-click="selectPage(page.number, $event)" >1</a></li>
                                            <li ng-if="::directionLinks" ng-className="{disabled: noNext()||ngDisabled}" className=" disabled"><a href="" ng-click="selectPage(page + 1, $event)" >Next</a></li>

                                        </ul>
                                    </div>
                                </div>

                                <div className="box-footer" data-ng-hide="collapsedGetReport">
                                    <button className="btn icon-btn delete  ng-hide" data-ng-show="countCombinedData" data-ng-click="deleteReport(getReportDate)">
                                        Delete Report
                                    </button>
                                    <button className="btn icon-btn edit  ng-hide" data-ng-show="countCombinedData != 0 &amp;&amp; invRefCheck.length &gt; 1" data-ng-click="">
                                        Invoice:  &amp;&amp; Amount:
                                    </button>
                                    <button className="icon-btn warning  ng-hide" data-ng-show="countCombinedData != 0 &amp;&amp; invRefCheck.length == 1" data-ng-click="openGenerateInvoice()">
                                        <i className="icon-plus1-circle"></i> Generate Invoice
                                    </button>
                                    <button className="icon-btn info btn-sm  ng-hide" data-ng-show="countCombinedData != 0" data-ng-click="reportDetailsExport()">
                                        <i className="icon-search1"></i> Export Data
                                    </button>
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>

            {
                (() => {
                    if (youtubeRedTemporaryTableStatus) {
                        return <YoutubeTemporaryBox param={youtubeRedTemporaryTableStatus} YoutubeTemporaryTableClose={YoutubeTemporaryTableClose}/>
                    }
                })()
            }
            {
                (() => {
                    if (fileUploadHistoryStatus) {
                        return <ViewUploadFileLogBox param={fileUploadHistoryStatus} />
                    }
                })()
            }

        </div>
    );
}
